import React, { FC } from 'react';
import { graphql } from 'gatsby';

import Portfolio, { IPortfolioProps } from 'components/Portfolio';

import Layout, { Head, Section } from 'components/Layout';

const PortfolioTemplate: FC<IPortfolioProps> = ({
  data,
  pageContext,
}) => (
  <Layout>
    <Head title="Portfolio" />

    <Section>
      <Portfolio
        title="Private portfolio"
        data={data}
        pageContext={pageContext}
      />
    </Section>

  </Layout>
);

export const query = graphql`
  query PortfolioPageQuery($stageRegex: String = "//", $sectorRegex: String = "//", $skip: Int!, $limit: Int!) {
    portfolioData: allContentfulPortfolioItem(
      filter: {
          stage: {
            title: {
              regex: $stageRegex
            }
          }
          sector: {
            title: {
              regex: $sectorRegex
            }
          }
      }
      sort: {
        fields: title
        order: ASC
      }
      limit: $limit
      skip: $skip
    ) {
      nodes {
        title
        text
        logo {
          file {
            url
          }
        }
      }
    }
  }
`;

export default PortfolioTemplate;
